// companySlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useInsertData } from "../../hooks/useInsertData";
import { useGetData } from "../../hooks/useGetData";
import { useUpdateData } from "../../hooks/useUpdateDate";
import useDeleteData from "../../hooks/useDeleteData";

export const createCompany = createAsyncThunk(
  "company/createCompany",
  async (data, { rejectWithValue }) => {
    try {
      const res = await useInsertData("companies", data);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const getAllCompanies = createAsyncThunk(
  "company/getAllCompanies",
  async (page = 1, { rejectWithValue }) => {
    try {
      const res = await useGetData(`companies?page=${page}`);
      return res;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

// إضافة thunk للبحث - جديد
export const searchCompanies = createAsyncThunk(
  "company/searchCompanies",
  async ({ keyword, page = 1 }, { rejectWithValue }) => {
    try {
      const res = await useGetData(
        `companies?keyword=${encodeURIComponent(keyword)}&page=${page}`
      );
      return res;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const getSpecificCompany = createAsyncThunk(
  "company/getSpecificCompany",
  async (id, { rejectWithValue }) => {
    try {
      const res = await useGetData(`companies/${id}`);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const updateCompany = createAsyncThunk(
  "company/updateCompany",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const res = await useUpdateData(`companies/${id}`, data);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const deleteCompany = createAsyncThunk(
  "company/deleteCompany",
  async (id, { rejectWithValue }) => {
    try {
      const res = await useDeleteData(`companies/${id}`);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

const initialState = {
  company: null,
  allCompanies: null,
  searchResults: null, // جديد
  statusUpdateCompany: null,
  specificCompany: null,
  status: "idle",
  searchStatus: "idle", // جديد
  error: null,
  token: null,
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.company = action.payload;
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getAllCompanies.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllCompanies.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allCompanies = action.payload;
        console.log("API Response:", action.payload);
      })
      .addCase(getAllCompanies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      // Search companies - جديد
      .addCase(searchCompanies.pending, (state) => {
        state.searchStatus = "loading";
        state.error = null;
      })
      .addCase(searchCompanies.fulfilled, (state, action) => {
        state.searchStatus = "succeeded";
        state.searchResults = action.payload;
      })
      .addCase(searchCompanies.rejected, (state, action) => {
        state.searchStatus = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getSpecificCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getSpecificCompany.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.specificCompany = action.payload;
      })
      .addCase(getSpecificCompany.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(updateCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateCompany.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(deleteCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(deleteCompany.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default companySlice.reducer;
